// import App from "next/app";
import "../elastic-apm.js";
import type { AppProps /* AppContext */, AppContext } from "next/app";
import {
  Box,
  ChakraProvider,
  ColorModeScript,
  useColorModeValue
} from "@chakra-ui/react";
import { theme } from "@/theme";
import Head from "next/head";
import { StoreContext, createStore, ThemeType } from "@/store";
import {
  useLocalObservable,
  enableStaticRendering,
  Observer
} from "mobx-react-lite";
import "@/global.css";
import i18n, { setLang } from "../i18n";
import { useEffect, useState } from "react";
interface MyAppProps {
  mode: ThemeType;
}
function MyApp({ Component, pageProps, mode }: MyAppProps & AppProps) {
  const store = useLocalObservable(createStore);
  enableStaticRendering(!process.browser);
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const params = window.location.search.slice(1).split("&");
      const paramsMap = new Map();
      params.forEach(item => {
        const temp = item.split("=");
        paramsMap.set(temp[0], temp[1]);
        const lang = setLang(paramsMap.get("lang"));
        i18n.changeLanguage(lang);

        document.documentElement.lang = lang;
      });
    }
  }, []);
  return (
    <>
      <Head>
        <meta name="color-scheme" content="dark light" />
      </Head>
      <StoreContext.Provider value={store}>
        <Observer>
          {() => (
            <Box dir="auto">
              {/* <ColorModeScript
                initialColorMode={theme.config.initialColorMode}
              /> */}
              <ChakraProvider theme={theme}>
                <Component {...pageProps} />
              </ChakraProvider>
            </Box>
          )}
        </Observer>
      </StoreContext.Provider>
    </>
  );
}

// Only uncomment this method if you have blocking data requirements for
// every single page in your application. This disables the ability to
// perform automatic static optimization, causing every page in your app to
// be server-side rendered.
//
MyApp.getInitialProps = async (appContext: AppContext) => {
  const mode = appContext.router.query.dark === undefined ? "light" : "dark";
  return {
    mode
  };
};

export default MyApp;
